import { Table } from '@nimbus-ds/components';
import { MetaplanItemResponseDto } from '@tiendanube/common';
import { MetaplansListDesktopRow } from './MetaplansListDesktopRow';
import { MetaplansListHeader } from './MetaplansListHeader';

interface MetaplansListTableProps {
  data: MetaplanItemResponseDto[];
}

export function MetaplansListTable({
  data,
}: Readonly<MetaplansListTableProps>) {
  return (
    <Table>
      <MetaplansListHeader />
      <Table.Body>
        {data.map((metaplan) => (
          <MetaplansListDesktopRow metaplan={metaplan} key={metaplan.id} />
        ))}
      </Table.Body>
    </Table>
  );
}
